'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fund_distribution_card = require('./fund_distribution_card');

var _fund_distribution_card2 = _interopRequireDefault(_fund_distribution_card);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _reactIntl = require('react-intl');

var _functional_utility2 = require('common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _custom_date_range_component = require('./custom_date_range_component');

var _custom_date_range_component2 = _interopRequireDefault(_custom_date_range_component);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _generic_fund_dividends_capital_gains_card = require('./generic_fund_dividends_capital_gains_card');

var _generic_fund_dividends_capital_gains_card2 = _interopRequireDefault(_generic_fund_dividends_capital_gains_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundDividendsCapitalGains = function (_React$Component) {
  _inherits(FundDividendsCapitalGains, _React$Component);

  function FundDividendsCapitalGains(props) {
    _classCallCheck(this, FundDividendsCapitalGains);

    var _this = _possibleConstructorReturn(this, (FundDividendsCapitalGains.__proto__ || Object.getPrototypeOf(FundDividendsCapitalGains)).call(this, props));

    _this.renderDateRangeComponent = function () {
      if ((0, _functional_utility.isDataEmpty)(_this.props.fundDistribution) || !_collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, 'TW_DIVIDEND_HISTORY')) {
        return null;
      }

      var validFromDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat((0, _ramda.last)(_this.props.fundDistribution).exDate, "YYYY-MM-DD"));
      var validToDate = (0, _moment2.default)(_date_formatter2.default.getDateInSpecificFormat(_this.props.fundDistribution[0].exDate, "YYYY-MM-DD"));

      var isShowDropdown = _collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, 'SHOW_DATE_RANGE_DROP_DOWN') || _collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, 'SHOW_TW_DATE_RANGE_DROP_DOWN');

      return _react2.default.createElement(_custom_date_range_component2.default, {
        id: "fundDistribution",
        validFromDate: validFromDate,
        validToDate: validToDate,
        filterData: _this.filterData,
        tooltip: _this.props.tooltip,
        count: 5,
        showDropdown: isShowDropdown,
        updateParent: function updateParent(data) {
          return _this.updateParent(data);
        },
        dateFormat: 'YYYY/MM/DD',
        dateRangeArray: _this.getDateRangeArray(validFromDate, validToDate),
        breakpoint: _this.props.breakpoint,
        visiblePoints: _this.props.visibleDataPoints });
    };

    _this.renderDividendScheduleCard = _this.renderDividendScheduleCard.bind(_this);
    _this.doesDataPointContains = _this.doesDataPointContains.bind(_this);
    _this.filterData = _this.filterData.bind(_this);
    _this.getDateRangeArray = _this.getDateRangeArray.bind(_this);
    _this.injectComponent = (0, _reactIntl.injectIntl)(_fund_distribution_card2.default);
    _this.state = {
      fundDistribution: _this.props.fundDistribution
    };
    return _this;
  }

  _createClass(FundDividendsCapitalGains, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.fundDistribution !== prevProps.fundDistribution) {
        this.setState({
          fundDistribution: this.props.fundDistribution
        });
      }
    }
  }, {
    key: 'shouldDisplayCard',
    value: function shouldDisplayCard(visibleCards, cardName) {
      return _collection_utility.CollectionUtility.includes(visibleCards, cardName);
    }
  }, {
    key: 'generateAnnualDividendPerShareTable',
    value: function generateAnnualDividendPerShareTable(annualDividendPerShare) {
      var _this2 = this;

      var headers = [_react2.default.createElement('td', { className: 'border-top-none' })];
      var tableData = [_react2.default.createElement(
        'td',
        { className: 'border-top-none category',
          'data-testid': 'annual-dividend-per-share-text' },
        'Total dividend per share (p)'
      )];
      var tableRow = _react2.default.createElement(
        'tr',
        { className: 'category' },
        tableData
      );
      _collection_utility.CollectionUtility.forEachIndexed(annualDividendPerShare, function (value) {
        headers.push(_react2.default.createElement(
          'td',
          { className: 'border-top-none tag',
            'data-testid': 'annual-dividend-per-share-year' },
          value.dividendYearValue
        ));
        tableData.push(_react2.default.createElement(
          'td',
          { className: 'border-top-none', 'data-testid': 'annual-dividend-per-share-value' },
          (0, _ramda.isNil)(value.annualDividendPerShareAmount) ? "-" : _react2.default.createElement(_formatted_number2.default, { value: _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(value.annualDividendPerShareAmount), numberFormat: _this2.props.numberFormat })
        ));
      });
      return _react2.default.createElement(_table_component2.default, {
        tableHeaders: headers,
        tableRows: tableRow,
        tableBodyTest: '',
        activeTab: this.props.active,
        breakpoint: this.props.breakpoint
      });
    }
  }, {
    key: 'renderDividendScheduleCard',
    value: function renderDividendScheduleCard() {
      var isDividendScheduleEmpty = _collection_utility.CollectionUtility.size(this.props.dividendData) < 1;
      if (this.doesDataPointContains("SHOW_DISTRIBUTION_TAB") || (0, _ramda.and)((0, _ramda.or)(this.doesDataPointContains('DIVIDEND_HISTORY_TAB'), this.doesDataPointContains("EMEA_DIVIDEND_HISTORY")), isDividendScheduleEmpty)) {
        return null;
      }

      return _react2.default.createElement(_generic_fund_dividends_capital_gains_card2.default, {
        data: this.props.dividendData,
        disclosures: this.props.disclosures,
        distributingCode: this.props.distributingCode,
        dividendsFrequencyLabel: this.props.dividendsFrequencyLabel,
        distributionFrequencyLabel: this.props.distributionFrequencyLabel,
        fundTypeCode: this.props.fundTypeCode,
        role: this.props.role,
        breakpoint: this.props.breakpoint,
        active: this.props.active,
        currencyCode: this.props.currencyCode,
        numberFormat: this.props.numberFormat,
        isDividendSchedule: true,
        visibleDataPoints: this.props.visibleDataPoints,
        formattingRules: this.props.formattingRules,
        tooltip: this.props.tooltip,
        shareclassData: this.props.shareClass,
        country: this.props.country,
        cusip: this.props.cusip,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl
      });
    }
  }, {
    key: 'renderCapitalGainsScheduleCard',
    value: function renderCapitalGainsScheduleCard() {
      if (this.doesDataPointContains("SHOW_DISTRIBUTION_TAB") || this.doesDataPointContains("REIT_DIVIDEND_HISTORY") || this.doesDataPointContains('DIVIDEND_HISTORY_TAB') || this.doesDataPointContains("EMEA_DIVIDEND_HISTORY")) {
        return null;
      }

      return _react2.default.createElement(_generic_fund_dividends_capital_gains_card2.default, {
        data: this.props.capitalGainsData,
        disclosures: this.props.disclosures,
        distributingCode: this.props.distributingCode,
        dividendsFrequencyLabel: this.props.dividendsFrequencyLabel,
        distributionFrequencyLabel: this.props.distributionFrequencyLabel,
        fundTypeCode: this.props.fundTypeCode,
        role: this.props.role,
        breakpoint: this.props.breakpoint,
        active: this.props.active,
        currencyCode: this.props.currencyCode,
        numberFormat: this.props.numberFormat,
        isDividendSchedule: false,
        visibleDataPoints: this.props.visibleDataPoints,
        formattingRules: this.props.formattingRules
      });
    }
  }, {
    key: 'renderAnnualDividendPerShare',
    value: function renderAnnualDividendPerShare() {
      if ((0, _functional_utility.isDataEmpty)(this.props.annualDividendPerShare)) {
        return null;
      } else {
        return _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: "Dividend history",
            headerTitleId: "dividendHistoryCard",
            headerTitleLabel: "dividend-history-card-header",
            disclosureText: null,
            placementId: null,
            breakpoint: this.props.breakpoint,
            headerLabel: null
          },
          this.generateAnnualDividendPerShareTable(this.props.annualDividendPerShare)
        );
      }
    }
  }, {
    key: 'getDateRangeArray',
    value: function getDateRangeArray(validFromDate, validToDate) {
      validToDate = (0, _moment2.default)(validToDate, 'YYYY-MM-DD');
      validFromDate = (0, _moment2.default)(validFromDate, 'YYYY-MM-DD');

      var yearMapArray = [{ years: 1, value: '12' }, { years: 3, value: '36' }, { years: 5, value: '60' }, { years: 10, value: '120' }, { years: 15, value: '180' }];

      var dateRangeArray = [{
        value: '0',
        displayValue: 'Since Inception',
        translationKey: 'since-inception'
      }];

      _date_formatter2.default.addYearMapsToDateRangeArray(dateRangeArray, yearMapArray, validToDate, validFromDate);

      return dateRangeArray;
    }
  }, {
    key: 'filterData',
    value: function filterData(fromDate, toDate) {
      var filteredFundDistribution = _collection_utility.CollectionUtility.filter(this.props.fundDistribution, function (fundDistribution) {
        return _moment2.default.utc((0, _moment2.default)(fundDistribution.exDate)).isBetween(fromDate, toDate, null, '[]');
      });

      if ((0, _functional_utility2.isNilOrEmpty)(filteredFundDistribution)) {
        return false;
      } else {
        this.setState({
          fundDistribution: filteredFundDistribution
        });
        return true;
      }
    }
  }, {
    key: 'updateParent',
    value: function updateParent(updatedData) {
      this.setState({
        filteredFundDistribution: (0, _ramda.isNil)(this.state.filteredFundDistribution) ? this.props.fundDistribution : this.state.filteredFundDistribution
      });
      var updatedState = _extends({}, this.state, updatedData);
      this.setState(updatedState);
    }
  }, {
    key: 'doesDataPointContains',
    value: function doesDataPointContains(visibleDataPointName) {
      return (0, _functional_utility.doesVisibleDataPointContains)(visibleDataPointName, this.props, ["visibleDataPoints"]);
    }
  }, {
    key: 'render',
    value: function render() {
      var IntlFundDistribuctionCard = this.injectComponent;
      var dateRangeComponent = this.renderDateRangeComponent();

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 print-full-width' },
        this.renderAnnualDividendPerShare(),
        this.renderDividendScheduleCard(),
        this.renderCapitalGainsScheduleCard(),
        this.shouldDisplayCard(this.props.visibleCards, "FUND_DISTRIBUTION_CARD") && _react2.default.createElement(IntlFundDistribuctionCard, { breakpoint: this.props.breakpoint,
          shareClass: this.props.shareClass,
          fundDistribution: this.state.fundDistribution,
          legalStructureCode: this.props.legalStructureCode,
          active: this.props.active,
          disclosures: this.props.disclosures,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          role: this.props.role,
          country: this.props.country,
          cusip: this.props.cusip,
          content: this.props.content,
          visibleDataPoints: this.props.visibleDataPoints,
          formattingRules: this.props.formattingRules,
          distributionFrequencyLabel: this.props.distributionFrequencyLabel,
          currencyCode: this.props.currencyCode,
          isShareclassMoreThanSixMonthsOld: this.props.isShareclassMoreThanSixMonthsOld,
          distributionFrequency: this.props.distributionFrequency,
          historicalBiMonthlyBonusList: this.props.historicalBiMonthlyBonusList,
          dateRangeComponent: dateRangeComponent
        })
      );
    }
  }]);

  return FundDividendsCapitalGains;
}(_react2.default.Component);

exports.default = FundDividendsCapitalGains;